var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('export-btn',_vm._b({ref:"refExportLink",staticStyle:{"display":"inline","font-size":"14px"},attrs:{"can-export":_vm.userPermissions.indexOf('plc_export')>-1,"lint-title":`导出`,"title":`下载刊例`,"class-name":"export-btn"},on:{"export":function($event){return _vm.exportData(_vm.searchCondition)}}},'export-btn',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }